import * as React from 'react';

const SvgNavSearchFill = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "m5.134 17.452-2.843 2.842 1.415 1.415 2.842-2.843-1.414-1.414ZM13 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z" })
);

export { SvgNavSearchFill as default };
//# sourceMappingURL=NavSearchFill.es.js.map
